import { useDrop } from 'react-dnd'
import styles from './Card.module.scss'
import { HeaUnit } from '../../../../types';
import ImageDropCursor from 'src/assets/icons/drop_cursor.svg?react'


type Props = {
  accept: string
  source: number
  onDrop: (item: HeaUnit) => void
}

function DropBox(props: Props) {
    const { accept, source, onDrop } = props

    const [{ isOver, canDrop }] = useDrop({
        accept,
        drop: onDrop,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    })

    const isActive = isOver && canDrop
    let dropCardStyle = styles.dropAdditionCard
    let label = "Drag and Drop Units"
    switch (source) {
        case 0:
            dropCardStyle = styles.dropUnitsCard
            label = "Drag and Drop Units here to remove"
            break
        default:
            dropCardStyle = styles.dropGradeCard
            break
    }
    if (isActive) {
        dropCardStyle = styles.dropGradeCard
    } else if (canDrop) {
        dropCardStyle = styles.dropUnitsCard
    }

    return (
        <div className={`${dropCardStyle} ${canDrop ? styles.canDropbackground : ''}`}>
            <div>
                <ImageDropCursor className={styles.dropImage}/>
                <p className={styles.labelPadding}>{label}</p>
            </div>
        </div>
    )
}

export default DropBox
